// extracted by mini-css-extract-plugin
module.exports = {"linkableBoxes":"linkable-boxes_linkableBoxes__KdfX9","singleBox":"linkable-boxes_singleBox___NqwZ"};